// extracted by mini-css-extract-plugin
export default {"ScrollUp":"ScrollUp_ScrollUp__R5d3D","icon":"ScrollUp_icon__QhGg4"};